import { GREY_BASIC } from "./color-palette";

export const CARD_CONTAINER_BOX_SHADOW = `rgb(0 0 0 / 15%) 0rem 1.25rem 1.6875rem 0rem`;
// NEW SHADOWS BELOW
export const PAGE_CONTAINER_BOX_SHADOW = `0 1px 0 ${GREY_BASIC}`;

export const DROP_SHADOW_BLACK = `0px 24px 56px 0px #0E1C2814`;
